import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { CoasVideoPreview } from "../utilities/youtubeVideoSongs";
class videoImage {
    constructor() {
        this.initPageConfig();
    }
    initPageConfig() {
        document.querySelectorAll('.abi-afrikaraoke-carousel').forEach((carousel) => {
            // Typecast carousel to HTMLElement
            const element = carousel;
            // Retrieve the 'itemperpage' attribute and parse it as a number
            const itemsPerPage = parseInt(element.getAttribute('itemperpage') || '4', 10); // Default to 4 if the attribute is missing or invalid
            // Initialize a new Splide instance with the parsed 'perPage' value
            new Splide(element, {
                arrows: false,
                pagination: true,
                gap: 47,
                perPage: itemsPerPage, // Use the parsed value from the attribute
                padding: '0%',
                breakpoints: {
                    767: {
                        gap: 10,
                        perPage: 1,
                        padding: '0%',
                        arrows: true,
                        pagination: false
                    },
                }
            }).mount();
        });
        // Init video component
        const videos = document.querySelectorAll(".abi__card-videos");
        if (videos) {
            videos.forEach(video => {
                if (video) {
                    const videoId = video.getAttribute("id");
                    const containerVideo = new CoasVideoPreview(videoId);
                    containerVideo.onInit();
                }
            });
        }
    }
}
window.addEventListener('load', function () {
    new videoImage();
});
